/**
 * GENERATED by scripts/tier-sync.mjs from server/src/lib/tiers.ts — do not edit.
 * Regenerate: node scripts/tier-sync.mjs   (runs automatically in `pnpm build`)
 */

export type TierKey = 'free' | 'pro';

export interface TierLimit {
  maxCorridors: number;
  maxPlansPerCorridor: number;
  maxIntersectionsPerCorridor: number;
  pdfExport: boolean;
  synchroImport: boolean;
  smartAutoSequence: boolean;
}

export const TIER_LIMIT: Record<TierKey, TierLimit> = {
  "free": {
    "maxCorridors": 3,
    "maxPlansPerCorridor": 2,
    "maxIntersectionsPerCorridor": 6,
    "pdfExport": false,
    "synchroImport": false,
    "smartAutoSequence": false
  },
  "pro": {
    "maxCorridors": 50,
    "maxPlansPerCorridor": 10,
    "maxIntersectionsPerCorridor": 12,
    "pdfExport": true,
    "synchroImport": true,
    "smartAutoSequence": true
  }
};
